export type Lang = "bg" | "br" | "en" | "fr" | "de" | "hi" | "ja" | "ko" | "es" | "tr";

export const LANGS: { code: Lang; label: string; flag: string; short: string; dir: "ltr" | "rtl" }[] = [
  { code: "bg", label: "Български", flag: "🇧🇬", short: "БГ", dir: "ltr" },
  { code: "br", label: "Português (BR)", flag: "🇧🇷", short: "BR", dir: "ltr" },
  { code: "en", label: "English", flag: "🇬🇧", short: "EN", dir: "ltr" },
  { code: "fr", label: "Français", flag: "🇫🇷", short: "FR", dir: "ltr" },
  { code: "de", label: "Deutsch", flag: "🇩🇪", short: "DE", dir: "ltr" },
  { code: "hi", label: "हिन्दी", flag: "🇮🇳", short: "हि", dir: "ltr" },
  { code: "ja", label: "日本語", flag: "🇯🇵", short: "日", dir: "ltr" },
  { code: "ko", label: "한국어", flag: "🇰🇷", short: "한", dir: "ltr" },
  { code: "es", label: "Español", flag: "🇪🇸", short: "ES", dir: "ltr" },
  { code: "tr", label: "Türkçe", flag: "🇹🇷", short: "TR", dir: "ltr" },
];

type Dict = Record<string, string>;

export const translations: Record<Lang, Dict> = {
  en: {
    "nav.styles": "Styles",
    "nav.pricing": "Pricing",
    "nav.reviews": "Reviews",
    "nav.cta": "Try Now",
    "hero.tag": "AI Cartoon Portrait Studio",
    "hero.title": "Your Punch Style",
    "hero.subtitle": "Upload a photo, pick a style, and get a stunning HD cartoon portrait in seconds",
    "hero.cta": "Generate My Style",
    "hero.stat1": "happy creators",
    "hero.stat2": "avg rating",
    "hero.stat3": "delivery",
    "examples.title": "See The Magic",
    "examples.subtitle": "Real before & after examples from PunchInk",
    "examples.before": "Before",
    "examples.petsNote": "Pets work with all styles!",
    "examples.after": "After",
    "styles.title": "Choose Your Style",
    "styles.subtitle": "",
    "style.cartoon": "Cartoon Classic",
    "style.anime": "Anime / Manga",
    "style.disney": "Disney / Pixar",
    "style.comic": "Comic Book",
    "style.neon": "Neon",
    "style.ghibli": "Ghibli",
    "style.oil": "Oil Painting",
    "style.headshot": "Headshot",
    "style.caricature": "Caricature",
    "style.neon.desc": "Cyberpunk glow, face preserved ~80%",
    "style.anime.desc": "Anime art style, face preserved ~75%",
    "style.comic.desc": "Bold comic style, face preserved ~85%",
    "style.cartoon.desc": "Classic cartoon, face preserved ~70%",
    "style.ghibli.desc": "Studio Ghibli magic, face preserved ~75%",
    "style.oil.desc": "Fine art portrait, face preserved ~90%",
    "style.disney.desc": "3D animation style, face preserved ~70%",
    "style.headshot.desc": "Professional photo, face preserved ~80%",
    "style.caricature.desc": "Best with close-up photos 😄",
    "premium.title": "Premium Styles",
    "style.pencil": "Pencil Sketch",
    "style.pencil.desc": "Hand-drawn pencil sketch portrait",
    "style.popart": "Pop Art",
    "style.popart.desc": "Bold, vibrant pop art colors",
    "style.vintage": "Vintage Comic",
    "style.vintage.desc": "Classic vintage comic book style",
    "style.watercolor": "Watercolor",
    "style.watercolor.desc": "Soft hand-painted watercolor portrait",
    "style.art_nouveau": "Art Nouveau",
    "style.art_nouveau.desc": "Elegant Mucha-inspired decorative art",
    "style.low_poly": "Low Poly",
    "style.low_poly.desc": "Modern geometric polygon portrait",
    "style.stained_glass": "Clay 3D",
    "style.stained_glass.desc": "Sculptural clay 3D art style",
    "badge.new": "NEW",
    "badge.soon": "Coming Soon",
    "mode.portrait": "👤 My Portrait",
    "mode.scene": "Full Scene",
    "mode.pet": "🐾 Pet Portrait",
    "mode.portraitDesc": "Your photo, your style, your Punch",
    "mode.sceneDesc": "",
    "mode.petDesc": "Your best friend. A new unforgettable look",
    "upload.title": "Upload Your Photo",
    "upload.subtitle": "Drag & drop or click to choose. Supports JPG, PNG, HEIC, HEIF, WEBP, AVIF, BMP, TIFF up to 10MB",
    "upload.cta": "Choose Photo",
    "upload.formats": "JPG, PNG, HEIC, WEBP, AVIF, BMP, TIFF · 10MB",
    "upload.generate": "Generate Style", "upload.deliveryInfo": "Your artwork will be generated after payment and delivered on the next screen.",
    "upload.generating": "Generating cartoon…",
    "upload.demoReady": "Demo ready — pay to unlock HD without watermark",
    "pricing.title": "Pricing",
    "pricing.subtitle": "Pay once. Download forever. No subscription.",
    "pricing.single": "Single Punch",
    "pricing.triple": "Punch Pack",
    "pricing.singleDesc": "1 HD Portrait",
    "pricing.tripleDesc": "3 HD Portraits",
    "pricing.popular": "Most Popular",
    "pricing.buy": "Get it now",
    "pricing.feat1": "Full HD download",
    "pricing.feat2": "No watermark",
    "pricing.feat3": "Commercial-use license",
    "pricing.feat4": "Instant delivery",
    "contact.title": "Contact",
    "contact.subtitle": "Questions, support, business inquiries, or partnerships — we're here to help!",
    "contact.mainLabel": "MAIN CONTACT",
    "pack.single": "Single Punch",

    "pack.triple": "Punch Pack",
    "pack.pickStyles": "Pick {n} styles",
    "pack.allStyles": "All 9 styles included",
    "footer.tagline": "",
    "footer.rights": "All rights reserved",
    "footer.privacy": "Privacy Policy",
    "footer.terms": "Terms & Conditions",
    "footer.cookies": "Cookie Policy",
    "footer.builtBy": "Built by SupremeCommerce.eu",
    "gdpr.text": "We use cookies to deliver our services and improve your experience. By using PunchInk you agree to our Cookie Policy.",
    "gdpr.accept": "Accept",
    "gdpr.decline": "Decline",
    "checkout.title": "Complete your purchase",
    "checkout.processing": "Processing payment…",
    "checkout.success": "Payment successful! Your HD cartoon is ready.",
    "checkout.download": "Download HD",
    "checkout.cancel": "Cancel",
    "checkout.downloadAll": "Download all",
    "checkout.itemSingle": "1 HD Cartoon",
    "checkout.itemMulti": "{n} HD Cartoons",
    "checkout.includes": "Includes commercial license, no watermark, full HD.",
    "checkout.payWith": "Pay with Stripe",
    "checkout.secure": "Secure checkout · 256-bit TLS · No card details stored",
    "common.lastUpdated": "Last updated",
    "privacy.title": "Privacy Policy",
    "privacy.intro": "PunchInk (\"we\", \"us\") respects your privacy. This Privacy Policy explains how we collect, use, and protect your information when you use punchink.com.",
    "privacy.s1Title": "1. Data we collect",
    "privacy.s1i1": "Photos you upload to generate cartoon portraits.",
    "privacy.s1i2": "Email and payment metadata processed by Stripe.",
    "privacy.s1i3": "Anonymous analytics (page views, language preference).",
    "privacy.s2Title": "2. How we use it",
    "privacy.s2Body": "Uploaded photos are processed by our AI generation service solely to produce the cartoon you request. They are deleted from our servers within 24 hours unless you explicitly save them.",
    "privacy.s3Title": "3. Payment data",
    "privacy.s3Body": "All payments are processed by Stripe. We never see or store your full card number.",
    "privacy.s4Title": "4. Your GDPR rights",
    "privacy.s4i1": "Right of access, rectification, and erasure of your data.",
    "privacy.s4i2": "Right to data portability and to lodge a complaint with your DPA.",
    "privacy.s4i3": "Email us to exercise these rights.",
    "privacy.s5Title": "5. Children",
    "privacy.s5Body": "PunchInk is not intended for users under 13.",
    "privacy.s6Title": "6. Contact",
    "terms.title": "Terms & Conditions",
    "terms.s1Title": "1. Service",
    "terms.s1Body": "PunchInk provides AI-generated cartoon portraits based on photos you upload. By using the Service you agree to these Terms.",
    "terms.s2Title": "2. Your content",
    "terms.s2Body": "You confirm that you own or have permission to upload any photo you submit. Do not upload images that infringe third-party rights, contain illegal content, or depict minors in inappropriate contexts.",
    "terms.s3Title": "3. License you receive",
    "terms.s3Body": "Upon successful payment, you receive a worldwide, perpetual, non-exclusive license to use the resulting HD cartoon for personal and commercial purposes.",
    "terms.s4Title": "4. Refunds",
    "terms.s4Body": "Because each cartoon is uniquely generated for you, all sales are final. Contact us if a generation fails.",
    "terms.s5Title": "5. Acceptable use",
    "terms.s5i1": "No hate speech, harassment, or sexually explicit content.",
    "terms.s5i2": "No impersonation of real public figures without consent.",
    "terms.s5i3": "No automated scraping or abuse of our APIs.",
    "terms.s6Title": "6. Liability",
    "terms.s6Body": "The Service is provided \"as is\". To the extent permitted by law, PunchInk's total liability is limited to the amount you paid in the last 12 months.",
    "terms.s7Title": "7. Governing law",
    "terms.s7Body": "These Terms are governed by the laws of the European Union. Disputes will be resolved in the competent courts of the EU member state where SupremeCommerce EOOD is registered.",
    "cookies.title": "Cookie Policy",
    "cookies.s1Title": "1. What are cookies?",
    "cookies.s1Body": "Cookies are small text files stored on your device that help websites function and remember your preferences.",
    "cookies.s2Title": "2. Cookies we use",
    "cookies.s2i1": "Essential: language preference, GDPR consent state, session.",
    "cookies.s2i2": "Analytics: anonymous usage statistics to improve the Service.",
    "cookies.s2i3": "Payment: Stripe sets cookies during checkout to prevent fraud.",
    "cookies.s3Title": "3. Managing cookies",
    "cookies.s3Body": "You can accept or decline non-essential cookies via the GDPR banner shown on first visit. You can also clear cookies in your browser settings at any time.",
    "cookies.s4Title": "4. Third parties",
    "cookies.s4Body": "We rely on Stripe (payments) and our analytics provider. Each operates under its own cookie policy.",
    "cookies.s5Title": "5. Contact",
  },
  bg: {
    "nav.styles": "Стилове", "nav.pricing": "Цени", "nav.reviews": "Отзиви", "nav.cta": "Опитай сега",
    "hero.tag": "AI Студио за Карикатурни Портрети", "hero.title": "Твоят Punch стил",
    "hero.subtitle": "Качи снимка, избери стил и получи поразителен HD карикатурен портрет за секунди",
    "hero.cta": "Създай моя стил",
    "hero.stat1": "доволни творци", "hero.stat2": "среден рейтинг", "hero.stat3": "доставка",
    "examples.title": "Виж магията", "examples.subtitle": "Истински примери преди и след от PunchInk",
    "examples.before": "Преди", "examples.after": "След",
    "examples.petsNote": "Домашните любимци работят с всички стилове!",
    "styles.title": "Избери своя стил", "styles.subtitle": "",
    "style.cartoon": "Класическа карикатура", "style.anime": "Аниме / Манга", "style.disney": "Дисни / Пиксар",
    "style.comic": "Комикс", "style.neon": "Неон", "style.ghibli": "Гибли", "style.oil": "Маслена живопис",
    "style.headshot": "Портретна снимка", "style.caricature": "Карикатура",
    "style.neon.desc": "Неоново киберпънк сияние, лицето запазено ~80%",
    "style.anime.desc": "Аниме художествен стил, лицето запазено ~75%",
    "style.comic.desc": "Смел комикс стил, лицето запазено ~85%",
    "style.cartoon.desc": "Класическа анимация, лицето запазено ~70%",
    "style.ghibli.desc": "Магия в стил Студио Гибли, лицето запазено ~75%",
    "style.oil.desc": "Изящен художествен портрет, лицето запазено ~90%",
    "style.disney.desc": "Триизмерна анимация, лицето запазено ~70%",
    "style.headshot.desc": "Професионална снимка, лицето запазено ~80%",
    "style.caricature.desc": "Най-добре работи с близки портретни снимки 😄",
    "mode.portrait": "👤 My Portrait", "mode.scene": "Пълна сцена", "mode.pet": "🐾 Pet Portrait",
    "mode.portraitDesc": "Your photo, your style, your Punch", "mode.sceneDesc": "", "mode.petDesc": "Your best friend. A new unforgettable look",
    "upload.title": "Качи своята снимка",
    "upload.subtitle": "Влачи и пусни или кликни. Поддържа JPG, PNG, HEIC, HEIF, WEBP, AVIF, BMP, TIFF до 10MB",
    "upload.cta": "Избери снимка", "upload.formats": "JPG, PNG, HEIC, WEBP, AVIF, BMP, TIFF · 10MB",
    "upload.generate": "Generate Style", "upload.deliveryInfo": "Your artwork will be generated after payment and delivered on the next screen.", "upload.generating": "Създаване на карикатура…",
    "upload.demoReady": "Демото е готово — плати, за да отключиш HD без воден знак",
    "pricing.title": "Цени", "pricing.subtitle": "Плати веднъж. Изтегляй завинаги. Без абонамент.",
    "pricing.popular": "Най-популярно", "pricing.buy": "Купи сега",
    "pricing.feat1": "Full HD изтегляне", "pricing.feat2": "Без воден знак", "pricing.feat3": "Лиценз за търговска употреба", "pricing.feat4": "Моментална доставка",
    "pack.pickStyles": "Избери {n} стила", "pack.allStyles": "Всичките 9 стила включени",
    
    "footer.tagline": "",
    "footer.rights": "Всички права запазени", "footer.privacy": "Поверителност", "footer.terms": "Общи условия", "footer.cookies": "Бисквитки",
    "footer.builtBy": "Създадено от SupremeCommerce.eu",
    "gdpr.text": "Използваме бисквитки, за да предоставяме услугите си и да подобряваме изживяването ви. Използвайки PunchInk се съгласявате с нашата Политика за бисквитки.",
    "gdpr.accept": "Приемам", "gdpr.decline": "Отказвам",
    "checkout.title": "Завърши покупката", "checkout.processing": "Обработка на плащането…",
    "checkout.success": "Плащането е успешно! Вашата HD карикатура е готова.", "checkout.download": "Изтегли HD", "checkout.cancel": "Отказ",
    "checkout.downloadAll": "Изтегли всички", "checkout.itemSingle": "1 HD карикатура", "checkout.itemMulti": "{n} HD карикатури",
    "checkout.includes": "Включва търговски лиценз, без воден знак, пълно HD.",
    "checkout.payWith": "Плати със Stripe", "checkout.secure": "Сигурно плащане · 256-битов TLS · Не се съхраняват данни от карта",
    "common.lastUpdated": "Последна актуализация",
    "privacy.title": "Политика за поверителност",
    "privacy.intro": "PunchInk („ние“) уважава вашата поверителност. Тази политика обяснява как събираме, използваме и защитаваме вашата информация, когато използвате punchink.com.",
    "privacy.s1Title": "1. Данни, които събираме",
    "privacy.s1i1": "Снимки, които качвате за генериране на карикатурни портрети.",
    "privacy.s1i2": "Имейл и метаданни за плащане, обработвани от Stripe.",
    "privacy.s1i3": "Анонимна аналитика (преглеждания на страници, езикови предпочитания).",
    "privacy.s2Title": "2. Как ги използваме",
    "privacy.s2Body": "Качените снимки се обработват от нашата AI услуга единствено за да се създаде заявената карикатура. Те се изтриват от сървърите ни в рамките на 24 часа, освен ако изрично не ги запазите.",
    "privacy.s3Title": "3. Данни за плащане",
    "privacy.s3Body": "Всички плащания се обработват от Stripe. Никога не виждаме и не съхраняваме пълния номер на картата ви.",
    "privacy.s4Title": "4. Вашите GDPR права",
    "privacy.s4i1": "Право на достъп, корекция и изтриване на вашите данни.",
    "privacy.s4i2": "Право на преносимост и подаване на жалба до вашия КЗЛД.",
    "privacy.s4i3": "Пишете ни, за да упражните тези права.",
    "privacy.s5Title": "5. Деца", "privacy.s5Body": "PunchInk не е предназначен за потребители под 13 години.",
    "privacy.s6Title": "6. Контакт",
    "terms.title": "Общи условия",
    "terms.s1Title": "1. Услуга",
    "terms.s1Body": "PunchInk предоставя AI-генерирани карикатурни портрети въз основа на снимките, които качвате. Използвайки услугата, вие се съгласявате с тези условия.",
    "terms.s2Title": "2. Вашето съдържание",
    "terms.s2Body": "Потвърждавате, че притежавате или имате разрешение да качите всяка изпратена снимка. Не качвайте изображения, които нарушават правата на трети страни, съдържат незаконно съдържание или изобразяват непълнолетни в неподходящ контекст.",
    "terms.s3Title": "3. Лиценз, който получавате",
    "terms.s3Body": "След успешно плащане получавате световен, безсрочен, неизключителен лиценз за използване на получената HD карикатура за лични и търговски цели.",
    "terms.s4Title": "4. Възстановяване",
    "terms.s4Body": "Тъй като всяка карикатура се създава уникално за вас, всички продажби са окончателни. Свържете се с нас, ако генерирането се провали.",
    "terms.s5Title": "5. Допустима употреба",
    "terms.s5i1": "Без реч на омраза, тормоз или сексуално експлицитно съдържание.",
    "terms.s5i2": "Без имитация на реални публични личности без съгласие.",
    "terms.s5i3": "Без автоматично извличане или злоупотреба с нашите API.",
    "terms.s6Title": "6. Отговорност",
    "terms.s6Body": "Услугата се предоставя „както е“. До степента, разрешена от закона, общата отговорност на PunchInk е ограничена до сумата, която сте платили през последните 12 месеца.",
    "terms.s7Title": "7. Приложимо право",
    "terms.s7Body": "Тези условия се уреждат от законите на Европейския съюз. Споровете се решават в компетентните съдилища на държавата-членка на ЕС, в която е регистрирана SupremeCommerce EOOD.",
    "cookies.title": "Политика за бисквитки",
    "cookies.s1Title": "1. Какво са бисквитките?",
    "cookies.s1Body": "Бисквитките са малки текстови файлове, съхранявани на устройството ви, които помагат на сайтовете да функционират и да запомнят предпочитанията ви.",
    "cookies.s2Title": "2. Бисквитки, които използваме",
    "cookies.s2i1": "Основни: езикови предпочитания, състояние на GDPR съгласие, сесия.",
    "cookies.s2i2": "Аналитични: анонимна статистика за подобряване на услугата.",
    "cookies.s2i3": "Плащане: Stripe задава бисквитки по време на плащане за предотвратяване на измами.",
    "cookies.s3Title": "3. Управление на бисквитките",
    "cookies.s3Body": "Можете да приемете или откажете незадължителните бисквитки чрез GDPR банера, показан при първото посещение. Можете също да изчистите бисквитките в настройките на браузъра си по всяко време.",
    "cookies.s4Title": "4. Трети страни",
    "cookies.s4Body": "Разчитаме на Stripe (плащания) и нашия доставчик на анализи. Всеки работи по своя политика за бисквитки.",
    "cookies.s5Title": "5. Контакт",
  },
  br: {
    "nav.styles": "Estilos", "nav.pricing": "Preços", "nav.reviews": "Avaliações", "nav.cta": "Experimentar",
    "hero.tag": "Estúdio de Retratos Cartoon com IA", "hero.title": "Seu Estilo Punch",
    "hero.subtitle": "Envie uma foto, escolha um estilo e receba um retrato cartoon em HD em segundos",
    "hero.cta": "Gerar meu estilo",
    "hero.stat1": "criadores felizes", "hero.stat2": "avaliação média", "hero.stat3": "entrega",
    "examples.title": "Veja a mágica", "examples.subtitle": "Exemplos reais de antes e depois do PunchInk",
    "examples.before": "Antes", "examples.after": "Depois",
    "examples.petsNote": "Pets funcionam com todos os estilos!",
    "styles.title": "Escolha seu estilo", "styles.subtitle": "",
    "style.cartoon": "Cartoon Clássico", "style.anime": "Anime / Mangá", "style.disney": "Disney / Pixar",
    "style.comic": "HQ", "style.neon": "Neon", "style.ghibli": "Ghibli", "style.oil": "Pintura a Óleo",
    "style.headshot": "Headshot", "style.caricature": "Caricatura",
    "style.neon.desc": "Brilho neon ciberpunk, rosto preservado ~80%",
    "style.anime.desc": "Estilo de arte anime, rosto preservado ~75%",
    "style.comic.desc": "Estilo de quadrinhos ousado, rosto preservado ~85%",
    "style.cartoon.desc": "Desenho animado clássico, rosto preservado ~70%",
    "style.ghibli.desc": "Magia do Studio Ghibli, rosto preservado ~75%",
    "style.oil.desc": "Retrato em pintura a óleo, rosto preservado ~90%",
    "style.disney.desc": "Estilo de animação 3D, rosto preservado ~70%",
    "style.headshot.desc": "Foto corporativa profissional, rosto preservado ~80%",
    "style.caricature.desc": "Melhor com fotos em close 😄",
    "mode.portrait": "👤 My Portrait", "mode.scene": "Cena Completa", "mode.pet": "🐾 Pet Portrait",
    "mode.portraitDesc": "Your photo, your style, your Punch", "mode.sceneDesc": "", "mode.petDesc": "Your best friend. A new unforgettable look",
    "upload.title": "Envie sua foto",
    "upload.subtitle": "Arraste ou clique. Suporta JPG, PNG, HEIC, HEIF, WEBP, AVIF, BMP, TIFF até 10MB",
    "upload.cta": "Escolher foto", "upload.formats": "JPG, PNG, HEIC, WEBP, AVIF, BMP, TIFF · 10MB",
    "upload.generate": "Generate Style", "upload.deliveryInfo": "Your artwork will be generated after payment and delivered on the next screen.", "upload.generating": "Gerando cartoon…",
    "upload.demoReady": "Demo pronto — pague para liberar HD sem marca d'água",
    "pricing.title": "Preços", "pricing.subtitle": "Pague uma vez. Baixe para sempre. Sem assinatura.",
    "pricing.popular": "Mais popular", "pricing.buy": "Comprar agora",
    "pricing.feat1": "Download Full HD", "pricing.feat2": "Sem marca d'água", "pricing.feat3": "Licença comercial", "pricing.feat4": "Entrega instantânea",
    "pack.pickStyles": "Escolha {n} estilos", "pack.allStyles": "Todos os 9 estilos incluídos",
    
    "footer.tagline": "",
    "footer.rights": "Todos os direitos reservados", "footer.privacy": "Política de Privacidade", "footer.terms": "Termos e Condições", "footer.cookies": "Política de Cookies",
    "footer.builtBy": "Feito por SupremeCommerce.eu",
    "gdpr.text": "Usamos cookies para melhorar sua experiência. Ao usar o PunchInk você concorda com nossa Política de Cookies.",
    "gdpr.accept": "Aceitar", "gdpr.decline": "Recusar",
    "checkout.title": "Concluir compra", "checkout.processing": "Processando pagamento…",
    "checkout.success": "Pagamento bem-sucedido! Seu cartoon HD está pronto.", "checkout.download": "Baixar HD", "checkout.cancel": "Cancelar",
    "checkout.downloadAll": "Baixar todos", "checkout.itemSingle": "1 Cartoon HD", "checkout.itemMulti": "{n} Cartoons HD",
    "checkout.includes": "Inclui licença comercial, sem marca d'água, full HD.",
    "checkout.payWith": "Pagar com Stripe", "checkout.secure": "Checkout seguro · TLS 256-bit · Dados do cartão não armazenados",
    "common.lastUpdated": "Última atualização",
    "privacy.title": "Política de Privacidade",
    "privacy.intro": "PunchInk (\"nós\") respeita sua privacidade. Esta Política explica como coletamos, usamos e protegemos suas informações ao usar punchink.com.",
    "privacy.s1Title": "1. Dados que coletamos",
    "privacy.s1i1": "Fotos enviadas para gerar retratos cartoon.",
    "privacy.s1i2": "Email e metadados de pagamento processados pelo Stripe.",
    "privacy.s1i3": "Análises anônimas (visitas, idioma preferido).",
    "privacy.s2Title": "2. Como usamos",
    "privacy.s2Body": "As fotos enviadas são processadas pelo nosso serviço de IA apenas para gerar o cartoon solicitado. Elas são excluídas dos nossos servidores em até 24 horas, a menos que você as salve.",
    "privacy.s3Title": "3. Dados de pagamento",
    "privacy.s3Body": "Todos os pagamentos são processados pelo Stripe. Nunca vemos ou armazenamos o número completo do seu cartão.",
    "privacy.s4Title": "4. Seus direitos LGPD/GDPR",
    "privacy.s4i1": "Direito de acesso, retificação e exclusão dos seus dados.",
    "privacy.s4i2": "Direito à portabilidade e a apresentar reclamação à autoridade competente.",
    "privacy.s4i3": "Envie email para exercer esses direitos.",
    "privacy.s5Title": "5. Crianças", "privacy.s5Body": "PunchInk não é destinado a usuários menores de 13 anos.",
    "privacy.s6Title": "6. Contato",
    "terms.title": "Termos e Condições",
    "terms.s1Title": "1. Serviço",
    "terms.s1Body": "PunchInk fornece retratos cartoon gerados por IA com base nas fotos enviadas. Ao usar o Serviço, você aceita estes Termos.",
    "terms.s2Title": "2. Seu conteúdo",
    "terms.s2Body": "Você confirma ter os direitos ou permissão para enviar qualquer foto. Não envie imagens que infrinjam direitos de terceiros, contenham conteúdo ilegal ou retratem menores em contextos inadequados.",
    "terms.s3Title": "3. Licença concedida",
    "terms.s3Body": "Após pagamento bem-sucedido, você recebe uma licença mundial, perpétua e não exclusiva para usar o cartoon HD para fins pessoais e comerciais.",
    "terms.s4Title": "4. Reembolsos",
    "terms.s4Body": "Como cada cartoon é gerado de forma única, todas as vendas são finais. Entre em contato se uma geração falhar.",
    "terms.s5Title": "5. Uso aceitável",
    "terms.s5i1": "Sem discurso de ódio, assédio ou conteúdo sexualmente explícito.",
    "terms.s5i2": "Sem personificação de figuras públicas reais sem consentimento.",
    "terms.s5i3": "Sem scraping automatizado ou abuso das nossas APIs.",
    "terms.s6Title": "6. Responsabilidade",
    "terms.s6Body": "O Serviço é fornecido \"como está\". Na medida permitida por lei, a responsabilidade total da PunchInk se limita ao valor pago nos últimos 12 meses.",
    "terms.s7Title": "7. Lei aplicável",
    "terms.s7Body": "Estes Termos são regidos pelas leis da União Europeia. Disputas serão resolvidas nos tribunais competentes do estado-membro da UE onde a SupremeCommerce EOOD está registrada.",
    "cookies.title": "Política de Cookies",
    "cookies.s1Title": "1. O que são cookies?",
    "cookies.s1Body": "Cookies são pequenos arquivos de texto armazenados no seu dispositivo que ajudam os sites a funcionar e a lembrar suas preferências.",
    "cookies.s2Title": "2. Cookies que usamos",
    "cookies.s2i1": "Essenciais: idioma, consentimento GDPR, sessão.",
    "cookies.s2i2": "Análise: estatísticas anônimas para melhorar o Serviço.",
    "cookies.s2i3": "Pagamento: Stripe define cookies durante o checkout para prevenir fraudes.",
    "cookies.s3Title": "3. Gerenciar cookies",
    "cookies.s3Body": "Você pode aceitar ou recusar cookies não essenciais via banner GDPR mostrado na primeira visita. Também pode limpar cookies nas configurações do navegador a qualquer momento.",
    "cookies.s4Title": "4. Terceiros",
    "cookies.s4Body": "Usamos Stripe (pagamentos) e nosso provedor de análise. Cada um opera sob sua própria política de cookies.",
    "cookies.s5Title": "5. Contato",
  },
  fr: {
    "nav.styles": "Styles", "nav.pricing": "Tarifs", "nav.reviews": "Avis", "nav.cta": "Essayer",
    "hero.tag": "Studio de Portraits Cartoon par IA", "hero.title": "Ton Style Punch",
    "hero.subtitle": "Téléverse une photo, choisis un style et obtiens un portrait cartoon HD en quelques secondes",
    "hero.cta": "Créer mon style",
    "hero.stat1": "créateurs ravis", "hero.stat2": "note moyenne", "hero.stat3": "livraison",
    "examples.title": "Voir la magie", "examples.subtitle": "Vrais exemples avant/après de PunchInk",
    "examples.before": "Avant", "examples.after": "Après",
    "examples.petsNote": "Les animaux fonctionnent avec tous les styles !",
    "styles.title": "Choisis ton style", "styles.subtitle": "",
    "style.cartoon": "Cartoon Classique", "style.anime": "Anime / Manga", "style.disney": "Disney / Pixar",
    "style.comic": "Comic Book", "style.neon": "Néon", "style.ghibli": "Ghibli", "style.oil": "Peinture à l'huile",
    "style.headshot": "Portrait Pro", "style.caricature": "Caricature",
    "style.neon.desc": "Lueur néon cyberpunk, visage préservé ~80%",
    "style.anime.desc": "Style artistique anime, visage préservé ~75%",
    "style.comic.desc": "Style bande dessinée audacieux, visage préservé ~85%",
    "style.cartoon.desc": "Dessin animé classique, visage préservé ~70%",
    "style.ghibli.desc": "Magie Studio Ghibli, visage préservé ~75%",
    "style.oil.desc": "Portrait à la peinture à l'huile, visage préservé ~90%",
    "style.disney.desc": "Style animation 3D, visage préservé ~70%",
    "style.headshot.desc": "Photo professionnelle, visage préservé ~80%",
    "style.caricature.desc": "Idéal avec des photos en gros plan 😄",
    "mode.portrait": "👤 My Portrait", "mode.scene": "Scène Complète", "mode.pet": "🐾 Pet Portrait",
    "mode.portraitDesc": "Your photo, your style, your Punch", "mode.sceneDesc": "", "mode.petDesc": "Your best friend. A new unforgettable look",
    "upload.title": "Téléverse ta photo",
    "upload.subtitle": "Glisse-dépose ou clique. Supporte JPG, PNG, HEIC, HEIF, WEBP, AVIF, BMP, TIFF jusqu'à 10MB",
    "upload.cta": "Choisir une photo", "upload.formats": "JPG, PNG, HEIC, WEBP, AVIF, BMP, TIFF · 10MB",
    "upload.generate": "Generate Style", "upload.deliveryInfo": "Your artwork will be generated after payment and delivered on the next screen.", "upload.generating": "Génération du cartoon…",
    "upload.demoReady": "Démo prête — paye pour débloquer le HD sans filigrane",
    "pricing.title": "Tarifs", "pricing.subtitle": "Paye une fois. Télécharge à vie. Sans abonnement.",
    "pricing.popular": "Le plus populaire", "pricing.buy": "Acheter",
    "pricing.feat1": "Téléchargement Full HD", "pricing.feat2": "Sans filigrane", "pricing.feat3": "Licence commerciale", "pricing.feat4": "Livraison instantanée",
    "pack.pickStyles": "Choisis {n} styles", "pack.allStyles": "Les 9 styles inclus",
    
    "footer.tagline": "",
    "footer.rights": "Tous droits réservés", "footer.privacy": "Politique de confidentialité", "footer.terms": "Conditions générales", "footer.cookies": "Politique de cookies",
    "footer.builtBy": "Créé par SupremeCommerce.eu",
    "gdpr.text": "Nous utilisons des cookies pour fournir nos services et améliorer votre expérience. En utilisant PunchInk vous acceptez notre Politique de cookies.",
    "gdpr.accept": "Accepter", "gdpr.decline": "Refuser",
    "checkout.title": "Finaliser l'achat", "checkout.processing": "Traitement du paiement…",
    "checkout.success": "Paiement réussi ! Ton cartoon HD est prêt.", "checkout.download": "Télécharger HD", "checkout.cancel": "Annuler",
    "checkout.downloadAll": "Tout télécharger", "checkout.itemSingle": "1 Cartoon HD", "checkout.itemMulti": "{n} Cartoons HD",
    "checkout.includes": "Inclut licence commerciale, sans filigrane, full HD.",
    "checkout.payWith": "Payer avec Stripe", "checkout.secure": "Paiement sécurisé · TLS 256-bit · Aucune donnée carte stockée",
    "common.lastUpdated": "Dernière mise à jour",
    "privacy.title": "Politique de confidentialité",
    "privacy.intro": "PunchInk (« nous ») respecte ta vie privée. Cette politique explique comment nous collectons, utilisons et protégeons tes informations sur punchink.com.",
    "privacy.s1Title": "1. Données collectées",
    "privacy.s1i1": "Photos téléversées pour générer des portraits cartoon.",
    "privacy.s1i2": "Email et métadonnées de paiement traitées par Stripe.",
    "privacy.s1i3": "Analyses anonymes (vues, langue préférée).",
    "privacy.s2Title": "2. Utilisation",
    "privacy.s2Body": "Les photos téléversées sont traitées par notre service IA uniquement pour produire le cartoon demandé. Elles sont supprimées de nos serveurs sous 24 heures sauf si tu les enregistres.",
    "privacy.s3Title": "3. Données de paiement",
    "privacy.s3Body": "Tous les paiements sont traités par Stripe. Nous ne voyons ni ne stockons jamais ton numéro de carte complet.",
    "privacy.s4Title": "4. Tes droits RGPD",
    "privacy.s4i1": "Droit d'accès, de rectification et d'effacement de tes données.",
    "privacy.s4i2": "Droit à la portabilité et de porter plainte auprès de ta CNIL.",
    "privacy.s4i3": "Écris-nous pour exercer ces droits.",
    "privacy.s5Title": "5. Mineurs", "privacy.s5Body": "PunchInk n'est pas destiné aux moins de 13 ans.",
    "privacy.s6Title": "6. Contact",
    "terms.title": "Conditions générales",
    "terms.s1Title": "1. Service",
    "terms.s1Body": "PunchInk fournit des portraits cartoon générés par IA basés sur tes photos. En utilisant le Service tu acceptes ces Conditions.",
    "terms.s2Title": "2. Ton contenu",
    "terms.s2Body": "Tu confirmes posséder ou avoir l'autorisation pour toute photo soumise. Ne téléverse pas d'images violant des droits tiers, contenant du contenu illégal ou représentant des mineurs dans des contextes inappropriés.",
    "terms.s3Title": "3. Licence accordée",
    "terms.s3Body": "Après paiement, tu reçois une licence mondiale, perpétuelle et non exclusive pour utiliser le cartoon HD à des fins personnelles et commerciales.",
    "terms.s4Title": "4. Remboursements",
    "terms.s4Body": "Chaque cartoon étant généré uniquement pour toi, toutes les ventes sont finales. Contacte-nous si une génération échoue.",
    "terms.s5Title": "5. Usage acceptable",
    "terms.s5i1": "Pas de discours de haine, harcèlement ou contenu sexuellement explicite.",
    "terms.s5i2": "Pas d'usurpation de personnalités publiques sans consentement.",
    "terms.s5i3": "Pas de scraping automatisé ou d'abus de nos API.",
    "terms.s6Title": "6. Responsabilité",
    "terms.s6Body": "Le Service est fourni « tel quel ». Dans la limite légale, la responsabilité totale de PunchInk se limite au montant payé les 12 derniers mois.",
    "terms.s7Title": "7. Loi applicable",
    "terms.s7Body": "Ces Conditions sont régies par le droit de l'Union européenne. Les litiges seront résolus devant les tribunaux compétents de l'État membre où SupremeCommerce EOOD est enregistrée.",
    "cookies.title": "Politique de cookies",
    "cookies.s1Title": "1. Que sont les cookies ?",
    "cookies.s1Body": "Les cookies sont de petits fichiers texte stockés sur ton appareil qui aident les sites à fonctionner et à mémoriser tes préférences.",
    "cookies.s2Title": "2. Cookies utilisés",
    "cookies.s2i1": "Essentiels : langue, consentement RGPD, session.",
    "cookies.s2i2": "Analyse : statistiques anonymes pour améliorer le Service.",
    "cookies.s2i3": "Paiement : Stripe définit des cookies au checkout pour prévenir la fraude.",
    "cookies.s3Title": "3. Gérer les cookies",
    "cookies.s3Body": "Tu peux accepter ou refuser les cookies non essentiels via la bannière RGPD à la première visite. Tu peux aussi effacer les cookies dans les paramètres de ton navigateur.",
    "cookies.s4Title": "4. Tiers",
    "cookies.s4Body": "Nous utilisons Stripe (paiements) et notre fournisseur d'analyse. Chacun opère sous sa propre politique de cookies.",
    "cookies.s5Title": "5. Contact",
  },
  de: {
    "nav.styles": "Stile", "nav.pricing": "Preise", "nav.reviews": "Bewertungen", "nav.cta": "Jetzt testen",
    "hero.tag": "KI-Cartoon-Porträt-Studio", "hero.title": "Dein Punch-Stil",
    "hero.subtitle": "Foto hochladen, Stil wählen und in Sekunden ein HD-Cartoon-Porträt erhalten",
    "hero.cta": "Meinen Stil erstellen",
    "hero.stat1": "zufriedene Creator", "hero.stat2": "Ø Bewertung", "hero.stat3": "Lieferung",
    "examples.title": "Sieh die Magie", "examples.subtitle": "Echte Vorher-Nachher-Beispiele von PunchInk",
    "examples.before": "Vorher", "examples.after": "Nachher",
    "examples.petsNote": "Haustiere funktionieren mit allen Stilen!",
    "styles.title": "Wähle deinen Stil", "styles.subtitle": "",
    "style.cartoon": "Cartoon Klassisch", "style.anime": "Anime / Manga", "style.disney": "Disney / Pixar",
    "style.comic": "Comic Book", "style.neon": "Neon", "style.ghibli": "Ghibli", "style.oil": "Ölgemälde",
    "style.headshot": "Headshot", "style.caricature": "Karikatur",
    "style.neon.desc": "Cyberpunk-Neonglühen, Gesicht erhalten ~80%",
    "style.anime.desc": "Anime-Kunststil, Gesicht erhalten ~75%",
    "style.comic.desc": "Mutiger Comic-Stil, Gesicht erhalten ~85%",
    "style.cartoon.desc": "Klassischer Zeichentrick, Gesicht erhalten ~70%",
    "style.ghibli.desc": "Studio-Ghibli-Magie, Gesicht erhalten ~75%",
    "style.oil.desc": "Ölgemälde-Porträt, Gesicht erhalten ~90%",
    "style.disney.desc": "3D-Animationsstil, Gesicht erhalten ~70%",
    "style.headshot.desc": "Professionelles Porträtfoto, Gesicht erhalten ~80%",
    "style.caricature.desc": "Am besten mit Nahaufnahmen 😄",
    "mode.portrait": "👤 My Portrait", "mode.scene": "Vollszene", "mode.pet": "🐾 Pet Portrait",
    "mode.portraitDesc": "Your photo, your style, your Punch", "mode.sceneDesc": "", "mode.petDesc": "Your best friend. A new unforgettable look",
    "upload.title": "Foto hochladen",
    "upload.subtitle": "Ziehen & ablegen oder klicken. Unterstützt JPG, PNG, HEIC, HEIF, WEBP, AVIF, BMP, TIFF bis 10MB",
    "upload.cta": "Foto wählen", "upload.formats": "JPG, PNG, HEIC, WEBP, AVIF, BMP, TIFF · 10MB",
    "upload.generate": "Generate Style", "upload.deliveryInfo": "Your artwork will be generated after payment and delivered on the next screen.", "upload.generating": "Cartoon wird generiert…",
    "upload.demoReady": "Demo bereit — bezahle, um HD ohne Wasserzeichen zu erhalten",
    "pricing.title": "Preise", "pricing.subtitle": "Einmal zahlen. Für immer herunterladen. Kein Abo.",
    "pricing.popular": "Beliebt", "pricing.buy": "Jetzt kaufen",
    "pricing.feat1": "Voll-HD-Download", "pricing.feat2": "Kein Wasserzeichen", "pricing.feat3": "Kommerzielle Lizenz", "pricing.feat4": "Sofortige Lieferung",
    "pack.pickStyles": "Wähle {n} Stile", "pack.allStyles": "Alle 9 Stile enthalten",
    
    "footer.tagline": "",
    "footer.rights": "Alle Rechte vorbehalten", "footer.privacy": "Datenschutz", "footer.terms": "AGB", "footer.cookies": "Cookie-Richtlinie",
    "footer.builtBy": "Erstellt von SupremeCommerce.eu",
    "gdpr.text": "Wir verwenden Cookies, um unsere Dienste bereitzustellen. Mit der Nutzung von PunchInk stimmst du unserer Cookie-Richtlinie zu.",
    "gdpr.accept": "Akzeptieren", "gdpr.decline": "Ablehnen",
    "checkout.title": "Kauf abschließen", "checkout.processing": "Zahlung wird verarbeitet…",
    "checkout.success": "Zahlung erfolgreich! Dein HD-Cartoon ist bereit.", "checkout.download": "HD herunterladen", "checkout.cancel": "Abbrechen",
    "checkout.downloadAll": "Alle herunterladen", "checkout.itemSingle": "1 HD-Cartoon", "checkout.itemMulti": "{n} HD-Cartoons",
    "checkout.includes": "Inkl. kommerzieller Lizenz, ohne Wasserzeichen, Full HD.",
    "checkout.payWith": "Mit Stripe bezahlen", "checkout.secure": "Sicheres Checkout · 256-bit TLS · Keine Kartendaten gespeichert",
    "common.lastUpdated": "Zuletzt aktualisiert",
    "privacy.title": "Datenschutzerklärung",
    "privacy.intro": "PunchInk (\"wir\") respektiert deine Privatsphäre. Diese Erklärung beschreibt, wie wir deine Daten auf punchink.com erheben, nutzen und schützen.",
    "privacy.s1Title": "1. Erhobene Daten",
    "privacy.s1i1": "Hochgeladene Fotos zur Erstellung von Cartoon-Porträts.",
    "privacy.s1i2": "E-Mail und Zahlungsmetadaten, verarbeitet durch Stripe.",
    "privacy.s1i3": "Anonyme Analysen (Seitenaufrufe, Spracheinstellung).",
    "privacy.s2Title": "2. Verwendung",
    "privacy.s2Body": "Hochgeladene Fotos werden ausschließlich zur Erstellung des angeforderten Cartoons verarbeitet. Sie werden innerhalb von 24 Stunden gelöscht, sofern du sie nicht ausdrücklich speicherst.",
    "privacy.s3Title": "3. Zahlungsdaten",
    "privacy.s3Body": "Alle Zahlungen werden von Stripe verarbeitet. Wir sehen oder speichern niemals deine vollständige Kartennummer.",
    "privacy.s4Title": "4. Deine DSGVO-Rechte",
    "privacy.s4i1": "Recht auf Auskunft, Berichtigung und Löschung.",
    "privacy.s4i2": "Recht auf Datenübertragbarkeit und Beschwerde bei deiner Aufsichtsbehörde.",
    "privacy.s4i3": "Schreib uns, um diese Rechte auszuüben.",
    "privacy.s5Title": "5. Kinder", "privacy.s5Body": "PunchInk ist nicht für Nutzer unter 13 Jahren bestimmt.",
    "privacy.s6Title": "6. Kontakt",
    "terms.title": "AGB",
    "terms.s1Title": "1. Dienst",
    "terms.s1Body": "PunchInk bietet KI-generierte Cartoon-Porträts auf Basis hochgeladener Fotos. Mit der Nutzung akzeptierst du diese AGB.",
    "terms.s2Title": "2. Deine Inhalte",
    "terms.s2Body": "Du bestätigst, dass du die Rechte oder Erlaubnis für jedes hochgeladene Foto besitzt. Lade keine Bilder hoch, die Rechte Dritter verletzen, illegale Inhalte enthalten oder Minderjährige unangemessen darstellen.",
    "terms.s3Title": "3. Erteilte Lizenz",
    "terms.s3Body": "Nach erfolgreicher Zahlung erhältst du eine weltweite, unbefristete, nicht exklusive Lizenz zur privaten und kommerziellen Nutzung des HD-Cartoons.",
    "terms.s4Title": "4. Rückerstattungen",
    "terms.s4Body": "Da jeder Cartoon individuell erstellt wird, sind alle Verkäufe endgültig. Kontaktiere uns bei fehlgeschlagener Generierung.",
    "terms.s5Title": "5. Akzeptable Nutzung",
    "terms.s5i1": "Keine Hassrede, Belästigung oder sexuell expliziten Inhalte.",
    "terms.s5i2": "Keine Identitätsfälschung realer Personen ohne Zustimmung.",
    "terms.s5i3": "Kein automatisiertes Scraping oder Missbrauch unserer APIs.",
    "terms.s6Title": "6. Haftung",
    "terms.s6Body": "Der Dienst wird \"wie besehen\" bereitgestellt. Soweit gesetzlich zulässig, ist die Haftung von PunchInk auf den in den letzten 12 Monaten gezahlten Betrag begrenzt.",
    "terms.s7Title": "7. Anwendbares Recht",
    "terms.s7Body": "Diese AGB unterliegen dem Recht der Europäischen Union. Streitigkeiten werden vor den zuständigen Gerichten des EU-Mitgliedstaates verhandelt, in dem SupremeCommerce EOOD registriert ist.",
    "cookies.title": "Cookie-Richtlinie",
    "cookies.s1Title": "1. Was sind Cookies?",
    "cookies.s1Body": "Cookies sind kleine Textdateien auf deinem Gerät, die Websites helfen zu funktionieren und deine Einstellungen zu speichern.",
    "cookies.s2Title": "2. Verwendete Cookies",
    "cookies.s2i1": "Essentiell: Sprache, DSGVO-Einwilligung, Sitzung.",
    "cookies.s2i2": "Analyse: anonyme Statistiken zur Verbesserung des Dienstes.",
    "cookies.s2i3": "Zahlung: Stripe setzt Cookies beim Checkout zur Betrugsprävention.",
    "cookies.s3Title": "3. Cookies verwalten",
    "cookies.s3Body": "Du kannst nicht-essentielle Cookies über das DSGVO-Banner beim ersten Besuch akzeptieren oder ablehnen. Du kannst Cookies jederzeit in den Browsereinstellungen löschen.",
    "cookies.s4Title": "4. Dritte",
    "cookies.s4Body": "Wir nutzen Stripe (Zahlungen) und unseren Analyseanbieter. Jeder arbeitet unter eigener Cookie-Richtlinie.",
    "cookies.s5Title": "5. Kontakt",
  },
  hi: {
    "nav.styles": "शैलियाँ", "nav.pricing": "मूल्य", "nav.reviews": "समीक्षाएं", "nav.cta": "अभी आज़माएं",
    "hero.tag": "AI कार्टून पोर्ट्रेट स्टूडियो", "hero.title": "आपका Punch स्टाइल",
    "hero.subtitle": "फोटो अपलोड करें, स्टाइल चुनें और सेकंडों में शानदार HD कार्टून पोर्ट्रेट पाएं",
    "hero.cta": "मेरा स्टाइल बनाएं",
    "hero.stat1": "खुश क्रिएटर्स", "hero.stat2": "औसत रेटिंग", "hero.stat3": "डिलीवरी",
    "examples.title": "जादू देखें", "examples.subtitle": "PunchInk से असली पहले और बाद के उदाहरण",
    "examples.before": "पहले", "examples.after": "बाद",
    "examples.petsNote": "पालतू जानवर सभी स्टाइल्स के साथ काम करते हैं!",
    "styles.title": "अपनी शैली चुनें", "styles.subtitle": "",
    "style.cartoon": "क्लासिक कार्टून", "style.anime": "एनिमे / मंगा", "style.disney": "डिज़्नी / पिक्सर",
    "style.comic": "कॉमिक बुक", "style.neon": "नियॉन", "style.ghibli": "घिबली", "style.oil": "ऑयल पेंटिंग",
    "style.headshot": "हेडशॉट", "style.caricature": "कैरिकेचर",
    "style.neon.desc": "साइबरपंक नियॉन चमक, चेहरा ~80% सुरक्षित",
    "style.anime.desc": "एनिमे कला शैली, चेहरा ~75% सुरक्षित",
    "style.comic.desc": "बोल्ड कॉमिक बुक शैली, चेहरा ~85% सुरक्षित",
    "style.cartoon.desc": "क्लासिक कार्टून शैली, चेहरा ~70% सुरक्षित",
    "style.ghibli.desc": "स्टूडियो घिबली का जादू, चेहरा ~75% सुरक्षित",
    "style.oil.desc": "तैल चित्रकला पोर्ट्रेट, चेहरा ~90% सुरक्षित",
    "style.disney.desc": "3डी एनिमेशन शैली, चेहरा ~70% सुरक्षित",
    "style.headshot.desc": "पेशेवर फोटो, चेहरा ~80% सुरक्षित",
    "style.caricature.desc": "क्लोज़-अप तस्वीरों के साथ सर्वश्रेष्ठ 😄",
    "mode.portrait": "👤 My Portrait", "mode.scene": "पूर्ण दृश्य", "mode.pet": "🐾 Pet Portrait",
    "mode.portraitDesc": "Your photo, your style, your Punch", "mode.sceneDesc": "", "mode.petDesc": "Your best friend. A new unforgettable look",
    "upload.title": "अपनी फोटो अपलोड करें",
    "upload.subtitle": "ड्रैग और ड्रॉप करें या क्लिक करें। JPG, PNG, HEIC, HEIF, WEBP, AVIF, BMP, TIFF 10MB तक समर्थित",
    "upload.cta": "फोटो चुनें", "upload.formats": "JPG, PNG, HEIC, WEBP, AVIF, BMP, TIFF · 10MB",
    "upload.generate": "Generate Style", "upload.deliveryInfo": "Your artwork will be generated after payment and delivered on the next screen.", "upload.generating": "कार्टून बनाया जा रहा है…",
    "upload.demoReady": "डेमो तैयार — बिना वॉटरमार्क HD अनलॉक करने के लिए भुगतान करें",
    "pricing.title": "मूल्य निर्धारण", "pricing.subtitle": "एक बार भुगतान करें। हमेशा डाउनलोड करें। कोई सदस्यता नहीं।",
    "pricing.popular": "सबसे लोकप्रिय", "pricing.buy": "अभी खरीदें",
    "pricing.feat1": "फुल HD डाउनलोड", "pricing.feat2": "कोई वॉटरमार्क नहीं", "pricing.feat3": "व्यावसायिक लाइसेंस", "pricing.feat4": "तुरंत डिलीवरी",
    "pack.pickStyles": "{n} शैलियाँ चुनें", "pack.allStyles": "सभी 9 शैलियाँ शामिल",
    
    "footer.tagline": "",
    "footer.rights": "सर्वाधिकार सुरक्षित", "footer.privacy": "गोपनीयता नीति", "footer.terms": "नियम और शर्तें", "footer.cookies": "कुकी नीति",
    "footer.builtBy": "SupremeCommerce.eu द्वारा निर्मित",
    "gdpr.text": "हम अपनी सेवाएं प्रदान करने और आपके अनुभव को बेहतर बनाने के लिए कुकीज़ का उपयोग करते हैं। PunchInk का उपयोग करके आप हमारी कुकी नीति से सहमत होते हैं।",
    "gdpr.accept": "स्वीकार करें", "gdpr.decline": "अस्वीकार करें",
    "checkout.title": "अपनी खरीद पूरी करें", "checkout.processing": "भुगतान संसाधित किया जा रहा है…",
    "checkout.success": "भुगतान सफल! आपका HD कार्टून तैयार है।", "checkout.download": "HD डाउनलोड करें", "checkout.cancel": "रद्द करें",
    "checkout.downloadAll": "सभी डाउनलोड करें", "checkout.itemSingle": "1 HD कार्टून", "checkout.itemMulti": "{n} HD कार्टून",
    "checkout.includes": "व्यावसायिक लाइसेंस, बिना वॉटरमार्क, फुल HD शामिल।",
    "checkout.payWith": "Stripe से भुगतान करें", "checkout.secure": "सुरक्षित चेकआउट · 256-बिट TLS · कोई कार्ड विवरण संग्रहीत नहीं",
    "common.lastUpdated": "अंतिम अद्यतन",
    "privacy.title": "गोपनीयता नीति",
    "privacy.intro": "PunchInk (\"हम\") आपकी गोपनीयता का सम्मान करता है। यह नीति बताती है कि हम punchink.com पर आपकी जानकारी कैसे एकत्र, उपयोग और सुरक्षित करते हैं।",
    "privacy.s1Title": "1. हम जो डेटा एकत्र करते हैं",
    "privacy.s1i1": "कार्टून पोर्ट्रेट बनाने के लिए अपलोड की गई फोटो।",
    "privacy.s1i2": "Stripe द्वारा संसाधित ईमेल और भुगतान मेटाडेटा।",
    "privacy.s1i3": "अनाम विश्लेषण (पेज व्यू, भाषा प्राथमिकता)।",
    "privacy.s2Title": "2. हम इसका उपयोग कैसे करते हैं",
    "privacy.s2Body": "अपलोड की गई फोटो हमारी AI सेवा द्वारा केवल अनुरोधित कार्टून बनाने के लिए संसाधित की जाती हैं। जब तक आप उन्हें स्पष्ट रूप से सहेजते नहीं हैं, वे 24 घंटों के भीतर हमारे सर्वर से हटा दी जाती हैं।",
    "privacy.s3Title": "3. भुगतान डेटा",
    "privacy.s3Body": "सभी भुगतान Stripe द्वारा संसाधित किए जाते हैं। हम कभी भी आपका पूरा कार्ड नंबर नहीं देखते या संग्रहीत नहीं करते।",
    "privacy.s4Title": "4. आपके GDPR अधिकार",
    "privacy.s4i1": "अपने डेटा तक पहुंच, सुधार और हटाने का अधिकार।",
    "privacy.s4i2": "डेटा पोर्टेबिलिटी और शिकायत दर्ज करने का अधिकार।",
    "privacy.s4i3": "इन अधिकारों का प्रयोग करने के लिए हमें ईमेल करें।",
    "privacy.s5Title": "5. बच्चे", "privacy.s5Body": "PunchInk 13 वर्ष से कम उम्र के उपयोगकर्ताओं के लिए नहीं है।",
    "privacy.s6Title": "6. संपर्क",
    "terms.title": "नियम और शर्तें",
    "terms.s1Title": "1. सेवा",
    "terms.s1Body": "PunchInk आपकी अपलोड की गई फोटो के आधार पर AI-जनित कार्टून पोर्ट्रेट प्रदान करता है। सेवा का उपयोग करके आप इन शर्तों से सहमत हैं।",
    "terms.s2Title": "2. आपकी सामग्री",
    "terms.s2Body": "आप पुष्टि करते हैं कि आप जिस फोटो को अपलोड करते हैं, उसके मालिक हैं या उसकी अनुमति है। ऐसी छवियां अपलोड न करें जो तीसरे पक्ष के अधिकारों का उल्लंघन करती हैं, अवैध सामग्री शामिल करती हैं, या नाबालिगों को अनुचित संदर्भ में दर्शाती हैं।",
    "terms.s3Title": "3. आपको प्राप्त लाइसेंस",
    "terms.s3Body": "सफल भुगतान पर, आपको परिणामी HD कार्टून का व्यक्तिगत और व्यावसायिक उपयोग करने के लिए विश्वव्यापी, स्थायी, गैर-विशेष लाइसेंस मिलता है।",
    "terms.s4Title": "4. रिफंड",
    "terms.s4Body": "क्योंकि प्रत्येक कार्टून आपके लिए विशिष्ट रूप से तैयार किया जाता है, सभी बिक्री अंतिम हैं। यदि जनरेशन विफल हो तो हमसे संपर्क करें।",
    "terms.s5Title": "5. स्वीकार्य उपयोग",
    "terms.s5i1": "कोई घृणास्पद भाषण, उत्पीड़न या यौन रूप से स्पष्ट सामग्री नहीं।",
    "terms.s5i2": "बिना सहमति के वास्तविक सार्वजनिक हस्तियों की नकल नहीं।",
    "terms.s5i3": "हमारे API का स्वचालित स्क्रैपिंग या दुरुपयोग नहीं।",
    "terms.s6Title": "6. दायित्व",
    "terms.s6Body": "सेवा \"जैसी है\" प्रदान की जाती है। कानून द्वारा अनुमत सीमा तक, PunchInk का कुल दायित्व पिछले 12 महीनों में आपके भुगतान की राशि तक सीमित है।",
    "terms.s7Title": "7. शासी कानून",
    "terms.s7Body": "ये शर्तें यूरोपीय संघ के कानूनों द्वारा शासित हैं। विवादों का समाधान उस EU सदस्य राज्य के सक्षम न्यायालयों में किया जाएगा जहां SupremeCommerce EOOD पंजीकृत है।",
    "cookies.title": "कुकी नीति",
    "cookies.s1Title": "1. कुकीज़ क्या हैं?",
    "cookies.s1Body": "कुकीज़ आपके डिवाइस पर संग्रहीत छोटी टेक्स्ट फाइलें हैं जो वेबसाइटों को कार्य करने और आपकी प्राथमिकताओं को याद रखने में मदद करती हैं।",
    "cookies.s2Title": "2. हम जो कुकीज़ उपयोग करते हैं",
    "cookies.s2i1": "आवश्यक: भाषा प्राथमिकता, GDPR सहमति स्थिति, सत्र।",
    "cookies.s2i2": "विश्लेषण: सेवा सुधार के लिए अनाम उपयोग आँकड़े।",
    "cookies.s2i3": "भुगतान: Stripe धोखाधड़ी रोकने के लिए चेकआउट के दौरान कुकीज़ सेट करता है।",
    "cookies.s3Title": "3. कुकीज़ प्रबंधन",
    "cookies.s3Body": "आप पहली बार दिखाए गए GDPR बैनर के माध्यम से गैर-आवश्यक कुकीज़ स्वीकार या अस्वीकार कर सकते हैं। आप अपने ब्राउज़र सेटिंग्स में किसी भी समय कुकीज़ साफ कर सकते हैं।",
    "cookies.s4Title": "4. तृतीय पक्ष",
    "cookies.s4Body": "हम Stripe (भुगतान) और हमारे विश्लेषण प्रदाता पर निर्भर हैं। प्रत्येक अपनी कुकी नीति के तहत संचालित होता है।",
    "cookies.s5Title": "5. संपर्क",
  },
  ja: {
    "nav.styles": "スタイル", "nav.pricing": "料金", "nav.reviews": "レビュー", "nav.cta": "今すぐ試す",
    "hero.tag": "AIカートゥーン・ポートレート・スタジオ", "hero.title": "君だけのパンチスタイル",
    "hero.subtitle": "写真をアップロードし、スタイルを選択して、数秒で高画質カートゥーン肖像を取得",
    "hero.cta": "マイスタイルを生成",
    "hero.stat1": "満足のクリエイター", "hero.stat2": "平均評価", "hero.stat3": "配信",
    "examples.title": "魔法を見る", "examples.subtitle": "PunchInkのリアルなビフォー&アフター事例",
    "examples.before": "Before", "examples.after": "After",
    "examples.petsNote": "ペットはすべてのスタイルで使えます！",
    "styles.title": "スタイルを選ぶ", "styles.subtitle": "",
    "style.cartoon": "カートゥーン クラシック", "style.anime": "アニメ / マンガ", "style.disney": "ディズニー / ピクサー",
    "style.comic": "コミックブック", "style.neon": "ネオン", "style.ghibli": "ジブリ", "style.oil": "油絵",
    "style.headshot": "ヘッドショット", "style.caricature": "カリカチュア",
    "style.neon.desc": "サイバーパンクなネオンの輝き、顔の保持率約80%",
    "style.anime.desc": "アニメ風アートスタイル、顔の保持率約75%",
    "style.comic.desc": "大胆なアメコミ風、顔の保持率約85%",
    "style.cartoon.desc": "クラシックなカートゥーン、顔の保持率約70%",
    "style.ghibli.desc": "スタジオジブリ風の魔法、顔の保持率約75%",
    "style.oil.desc": "油絵風の肖像画、顔の保持率約90%",
    "style.disney.desc": "3Dアニメーション風、顔の保持率約70%",
    "style.headshot.desc": "プロフェッショナル写真、顔の保持率約80%",
    "style.caricature.desc": "クローズアップ写真に最適 😄",
    "mode.portrait": "👤 My Portrait", "mode.scene": "フルシーン", "mode.pet": "🐾 Pet Portrait",
    "mode.portraitDesc": "Your photo, your style, your Punch", "mode.sceneDesc": "", "mode.petDesc": "Your best friend. A new unforgettable look",
    "upload.title": "写真をアップロード",
    "upload.subtitle": "ドラッグ＆ドロップまたはクリック。JPG、PNG、HEIC、HEIF、WEBP、AVIF、BMP、TIFF 10MBまで対応",
    "upload.cta": "写真を選ぶ", "upload.formats": "JPG, PNG, HEIC, WEBP, AVIF, BMP, TIFF · 10MB",
    "upload.generate": "Generate Style", "upload.deliveryInfo": "Your artwork will be generated after payment and delivered on the next screen.", "upload.generating": "生成中…",
    "upload.demoReady": "デモ完成 — お支払いでHD・透かしなしを解放",
    "pricing.title": "料金", "pricing.subtitle": "1回のお支払い。永久ダウンロード。サブスク不要。",
    "pricing.popular": "人気No.1", "pricing.buy": "購入する",
    "pricing.feat1": "フルHDダウンロード", "pricing.feat2": "透かしなし", "pricing.feat3": "商用ライセンス", "pricing.feat4": "即時配信",
    "pack.pickStyles": "{n}スタイルを選択", "pack.allStyles": "全9スタイル含む",
    
    "footer.tagline": "",
    "footer.rights": "全著作権所有", "footer.privacy": "プライバシーポリシー", "footer.terms": "利用規約", "footer.cookies": "クッキーポリシー",
    "footer.builtBy": "SupremeCommerce.eu 制作",
    "gdpr.text": "クッキーを使用してサービスを提供します。PunchInkを使用することでクッキーポリシーに同意したものとみなされます。",
    "gdpr.accept": "同意する", "gdpr.decline": "拒否",
    "checkout.title": "購入を完了する", "checkout.processing": "決済処理中…",
    "checkout.success": "決済成功！HDカートゥーンが準備できました。", "checkout.download": "HDをダウンロード", "checkout.cancel": "キャンセル",
    "checkout.downloadAll": "すべてダウンロード", "checkout.itemSingle": "HDカートゥーン1枚", "checkout.itemMulti": "HDカートゥーン{n}枚",
    "checkout.includes": "商用ライセンス、透かしなし、フルHD含む。",
    "checkout.payWith": "Stripeで支払う", "checkout.secure": "安全な決済 · 256-bit TLS · カード情報は保存されません",
    "common.lastUpdated": "最終更新",
    "privacy.title": "プライバシーポリシー",
    "privacy.intro": "PunchInk（「当社」）はあなたのプライバシーを尊重します。本ポリシーはpunchink.comでの情報の収集・利用・保護方法を説明します。",
    "privacy.s1Title": "1. 収集するデータ",
    "privacy.s1i1": "カートゥーン肖像を生成するためにアップロードされた写真。",
    "privacy.s1i2": "Stripeが処理するメールと支払いメタデータ。",
    "privacy.s1i3": "匿名分析（ページビュー、言語設定）。",
    "privacy.s2Title": "2. 利用方法",
    "privacy.s2Body": "アップロードされた写真は、ご要望のカートゥーンを生成する目的のみで処理されます。明示的に保存しない限り、24時間以内にサーバーから削除されます。",
    "privacy.s3Title": "3. 支払いデータ",
    "privacy.s3Body": "すべての支払いはStripeにより処理されます。当社はカード番号全体を見たり保存したりすることはありません。",
    "privacy.s4Title": "4. GDPR上の権利",
    "privacy.s4i1": "アクセス、訂正、消去の権利。",
    "privacy.s4i2": "データポータビリティおよびDPAへの苦情申立ての権利。",
    "privacy.s4i3": "これらの権利を行使するにはメールでご連絡ください。",
    "privacy.s5Title": "5. 子ども", "privacy.s5Body": "PunchInkは13歳未満のユーザーを対象としていません。",
    "privacy.s6Title": "6. お問い合わせ",
    "terms.title": "利用規約",
    "terms.s1Title": "1. サービス",
    "terms.s1Body": "PunchInkはアップロードされた写真をもとにAI生成のカートゥーン肖像を提供します。本サービスを利用することで本規約に同意したものとみなします。",
    "terms.s2Title": "2. ユーザーコンテンツ",
    "terms.s2Body": "送信する写真について、所有権または権限を有することを保証してください。第三者の権利を侵害する画像、違法な内容、不適切な文脈での未成年者の画像をアップロードしないでください。",
    "terms.s3Title": "3. 付与されるライセンス",
    "terms.s3Body": "支払い完了後、HDカートゥーンを個人および商用目的で使用するための世界的・永続的・非独占的ライセンスを取得します。",
    "terms.s4Title": "4. 返金",
    "terms.s4Body": "各カートゥーンは固有に生成されるため、すべての販売は最終とします。生成に失敗した場合はご連絡ください。",
    "terms.s5Title": "5. 利用規範",
    "terms.s5i1": "ヘイトスピーチ、ハラスメント、性的に露骨なコンテンツは禁止。",
    "terms.s5i2": "同意のない実在の公人のなりすましは禁止。",
    "terms.s5i3": "自動スクレイピングやAPIの不正使用は禁止。",
    "terms.s6Title": "6. 責任",
    "terms.s6Body": "本サービスは「現状のまま」提供されます。法令で許容される範囲で、PunchInkの総責任は過去12ヶ月にお支払いいただいた金額に限定されます。",
    "terms.s7Title": "7. 準拠法",
    "terms.s7Body": "本規約は欧州連合の法律に準拠します。紛争はSupremeCommerce EOODが登録されているEU加盟国の管轄裁判所で解決されます。",
    "cookies.title": "クッキーポリシー",
    "cookies.s1Title": "1. クッキーとは？",
    "cookies.s1Body": "クッキーはデバイスに保存される小さなテキストファイルで、ウェブサイトの機能と設定の記憶を助けます。",
    "cookies.s2Title": "2. 使用するクッキー",
    "cookies.s2i1": "必須: 言語設定、GDPR同意状態、セッション。",
    "cookies.s2i2": "分析: サービス改善のための匿名統計。",
    "cookies.s2i3": "支払い: Stripeが詐欺防止のため決済中にクッキーを設定。",
    "cookies.s3Title": "3. クッキー管理",
    "cookies.s3Body": "初回訪問時に表示されるGDPRバナーから非必須クッキーを承諾または拒否できます。ブラウザ設定からいつでもクッキーを削除できます。",
    "cookies.s4Title": "4. 第三者",
    "cookies.s4Body": "Stripe（決済）と分析プロバイダーを利用しています。各社は独自のクッキーポリシーで運営されています。",
    "cookies.s5Title": "5. お問い合わせ",
  },
  ko: {
    "nav.styles": "스타일", "nav.pricing": "가격", "nav.reviews": "리뷰", "nav.cta": "지금 체험",
    "hero.tag": "AI 카툰 초상화 스튜디오", "hero.title": "당신만의 펀치 스타일",
    "hero.subtitle": "사진을 업로드하고 스타일을 선택하면 몇 초 안에 멋진 HD 카툰 초상화를 받을 수 있습니다",
    "hero.cta": "내 스타일 만들기",
    "hero.stat1": "행복한 크리에이터", "hero.stat2": "평균 평점", "hero.stat3": "딜리버리",
    "examples.title": "마법을 보세요", "examples.subtitle": "PunchInk의 실제 비포 & 애프터 사례",
    "examples.before": "Before", "examples.after": "After",
    "examples.petsNote": "반려동물은 모든 스타일에 사용 가능!",
    "styles.title": "스타일을 선택하세요", "styles.subtitle": "",
    "style.cartoon": "클래식 카툰", "style.anime": "애니메 / 망가", "style.disney": "디즈니 / 픽사",
    "style.comic": "코믹북", "style.neon": "네온", "style.ghibli": "지브리", "style.oil": "유화",
    "style.headshot": "헤드샷", "style.caricature": "캐리커처",
    "style.neon.desc": "사이버펑크 네온 빛, 얼굴 보존 ~80%",
    "style.anime.desc": "애니메이션 아트 스타일, 얼굴 보존 ~75%",
    "style.comic.desc": "대담한 코믹북 스타일, 얼굴 보존 ~85%",
    "style.cartoon.desc": "클래식 만화 스타일, 얼굴 보존 ~70%",
    "style.ghibli.desc": "스튜디오 지브리 마법, 얼굴 보존 ~75%",
    "style.oil.desc": "유화 초상화, 얼굴 보존 ~90%",
    "style.disney.desc": "3D 애니메이션 스타일, 얼굴 보존 ~70%",
    "style.headshot.desc": "전문 인물 사진, 얼굴 보존 ~80%",
    "style.caricature.desc": "클로즈업 사진에 가장 적합 😄",
    "mode.portrait": "👤 My Portrait", "mode.scene": "전체 장면", "mode.pet": "🐾 Pet Portrait",
    "mode.portraitDesc": "Your photo, your style, your Punch", "mode.sceneDesc": "", "mode.petDesc": "Your best friend. A new unforgettable look",
    "upload.title": "사진 업로드",
    "upload.subtitle": "드래그 앤 드롭 또는 클릭. JPG, PNG, HEIC, HEIF, WEBP, AVIF, BMP, TIFF 10MB까지 지원",
    "upload.cta": "사진 선택", "upload.formats": "JPG, PNG, HEIC, WEBP, AVIF, BMP, TIFF · 10MB",
    "upload.generate": "Generate Style", "upload.deliveryInfo": "Your artwork will be generated after payment and delivered on the next screen.", "upload.generating": "카툰 생성 중…",
    "upload.demoReady": "데모 준비 완료 — 결제하여 워터마크 없는 HD 잠금 해제",
    "pricing.title": "가격", "pricing.subtitle": "한 번 결제. 평생 다운로드. 구독 없음.",
    "pricing.popular": "가장 인기", "pricing.buy": "지금 구매",
    "pricing.feat1": "Full HD 다운로드", "pricing.feat2": "워터마크 없음", "pricing.feat3": "상업용 라이선스", "pricing.feat4": "즉시 전달",
    "pack.pickStyles": "{n}개 스타일 선택", "pack.allStyles": "9개 스타일 모두 포함",
    
    "footer.tagline": "",
    "footer.rights": "모든 권리 보유", "footer.privacy": "개인정보 처리방침", "footer.terms": "이용약관", "footer.cookies": "쿠키 정책",
    "footer.builtBy": "SupremeCommerce.eu 제작",
    "gdpr.text": "서비스 제공과 경험 향상을 위해 쿠키를 사용합니다. PunchInk를 사용함으로써 쿠키 정책에 동의합니다.",
    "gdpr.accept": "수락", "gdpr.decline": "거부",
    "checkout.title": "구매 완료", "checkout.processing": "결제 처리 중…",
    "checkout.success": "결제 성공! HD 카툰이 준비되었습니다.", "checkout.download": "HD 다운로드", "checkout.cancel": "취소",
    "checkout.downloadAll": "모두 다운로드", "checkout.itemSingle": "HD 카툰 1개", "checkout.itemMulti": "HD 카툰 {n}개",
    "checkout.includes": "상업용 라이선스, 워터마크 없음, full HD 포함.",
    "checkout.payWith": "Stripe로 결제", "checkout.secure": "안전한 결제 · 256-bit TLS · 카드 정보 저장되지 않음",
    "common.lastUpdated": "최종 업데이트",
    "privacy.title": "개인정보 처리방침",
    "privacy.intro": "PunchInk(\"당사\")는 귀하의 개인정보를 존중합니다. 본 방침은 punchink.com에서 정보를 수집·이용·보호하는 방법을 설명합니다.",
    "privacy.s1Title": "1. 수집하는 데이터",
    "privacy.s1i1": "카툰 초상화 생성을 위해 업로드된 사진.",
    "privacy.s1i2": "Stripe가 처리하는 이메일 및 결제 메타데이터.",
    "privacy.s1i3": "익명 분석 (페이지 뷰, 언어 설정).",
    "privacy.s2Title": "2. 사용 방법",
    "privacy.s2Body": "업로드된 사진은 요청한 카툰 생성 목적으로만 AI 서비스에서 처리됩니다. 명시적으로 저장하지 않는 한 24시간 이내에 서버에서 삭제됩니다.",
    "privacy.s3Title": "3. 결제 데이터",
    "privacy.s3Body": "모든 결제는 Stripe에서 처리됩니다. 당사는 카드 번호 전체를 보거나 저장하지 않습니다.",
    "privacy.s4Title": "4. GDPR 권리",
    "privacy.s4i1": "데이터 접근, 정정, 삭제 권리.",
    "privacy.s4i2": "데이터 이동성 및 DPA에 불만 제기 권리.",
    "privacy.s4i3": "이러한 권리를 행사하려면 이메일로 연락하세요.",
    "privacy.s5Title": "5. 어린이", "privacy.s5Body": "PunchInk는 13세 미만 사용자를 대상으로 하지 않습니다.",
    "privacy.s6Title": "6. 연락처",
    "terms.title": "이용약관",
    "terms.s1Title": "1. 서비스",
    "terms.s1Body": "PunchInk는 업로드된 사진을 기반으로 AI 생성 카툰 초상화를 제공합니다. 서비스 이용 시 본 약관에 동의하는 것으로 간주됩니다.",
    "terms.s2Title": "2. 사용자 콘텐츠",
    "terms.s2Body": "제출하는 모든 사진에 대한 소유권 또는 권한을 보유함을 확인합니다. 제3자의 권리를 침해하거나 불법 콘텐츠를 포함하거나 부적절한 맥락에서 미성년자를 묘사하는 이미지를 업로드하지 마십시오.",
    "terms.s3Title": "3. 부여되는 라이선스",
    "terms.s3Body": "결제 완료 시, 결과 HD 카툰을 개인 및 상업적 목적으로 사용할 수 있는 전 세계적, 영구적, 비독점적 라이선스가 부여됩니다.",
    "terms.s4Title": "4. 환불",
    "terms.s4Body": "각 카툰은 사용자만을 위해 고유하게 생성되므로 모든 판매는 최종입니다. 생성 실패 시 연락 주십시오.",
    "terms.s5Title": "5. 허용 사용",
    "terms.s5i1": "혐오 발언, 괴롭힘, 성적으로 노골적인 콘텐츠 금지.",
    "terms.s5i2": "동의 없는 실제 공인 사칭 금지.",
    "terms.s5i3": "API 자동 스크래핑 또는 남용 금지.",
    "terms.s6Title": "6. 책임",
    "terms.s6Body": "서비스는 \"있는 그대로\" 제공됩니다. 법률이 허용하는 한도 내에서 PunchInk의 총 책임은 지난 12개월 동안 지불한 금액으로 제한됩니다.",
    "terms.s7Title": "7. 준거법",
    "terms.s7Body": "본 약관은 유럽 연합 법률에 따릅니다. 분쟁은 SupremeCommerce EOOD가 등록된 EU 회원국의 관할 법원에서 해결됩니다.",
    "cookies.title": "쿠키 정책",
    "cookies.s1Title": "1. 쿠키란?",
    "cookies.s1Body": "쿠키는 웹사이트가 작동하고 환경설정을 기억하도록 도와주는, 기기에 저장되는 작은 텍스트 파일입니다.",
    "cookies.s2Title": "2. 사용하는 쿠키",
    "cookies.s2i1": "필수: 언어 설정, GDPR 동의 상태, 세션.",
    "cookies.s2i2": "분석: 서비스 개선을 위한 익명 사용 통계.",
    "cookies.s2i3": "결제: Stripe가 사기 방지를 위해 결제 중 쿠키 설정.",
    "cookies.s3Title": "3. 쿠키 관리",
    "cookies.s3Body": "첫 방문 시 표시되는 GDPR 배너에서 비필수 쿠키를 수락하거나 거부할 수 있습니다. 브라우저 설정에서 언제든 쿠키를 삭제할 수도 있습니다.",
    "cookies.s4Title": "4. 제3자",
    "cookies.s4Body": "Stripe(결제) 및 분석 제공자를 사용합니다. 각자 자체 쿠키 정책을 따릅니다.",
    "cookies.s5Title": "5. 연락처",
  },
  es: {
    "nav.styles": "Estilos", "nav.pricing": "Precios", "nav.reviews": "Opiniones", "nav.cta": "Probar",
    "hero.tag": "Estudio de Retratos Cartoon con IA", "hero.title": "Tu Estilo Punch",
    "hero.subtitle": "Sube una foto, elige un estilo y obtén un retrato cartoon en HD en segundos",
    "hero.cta": "Generar mi estilo",
    "hero.stat1": "creadores felices", "hero.stat2": "valoración media", "hero.stat3": "entrega",
    "examples.title": "Mira la magia", "examples.subtitle": "Ejemplos reales antes y después de PunchInk",
    "examples.before": "Antes", "examples.after": "Después",
    "examples.petsNote": "¡Las mascotas funcionan con todos los estilos!",
    "styles.title": "Elige tu estilo", "styles.subtitle": "",
    "style.cartoon": "Cartoon Clásico", "style.anime": "Anime / Manga", "style.disney": "Disney / Pixar",
    "style.comic": "Cómic", "style.neon": "Neón", "style.ghibli": "Ghibli", "style.oil": "Óleo",
    "style.headshot": "Headshot", "style.caricature": "Caricatura",
    "style.neon.desc": "Brillo neón ciberpunk, rostro preservado ~80%",
    "style.anime.desc": "Estilo artístico anime, rostro preservado ~75%",
    "style.comic.desc": "Estilo de cómic audaz, rostro preservado ~85%",
    "style.cartoon.desc": "Dibujo animado clásico, rostro preservado ~70%",
    "style.ghibli.desc": "Magia del Studio Ghibli, rostro preservado ~75%",
    "style.oil.desc": "Retrato al óleo, rostro preservado ~90%",
    "style.disney.desc": "Estilo de animación 3D, rostro preservado ~70%",
    "style.headshot.desc": "Foto profesional de retrato, rostro preservado ~80%",
    "style.caricature.desc": "Mejor con fotos en primer plano 😄",
    "mode.portrait": "👤 My Portrait", "mode.scene": "Escena Completa", "mode.pet": "🐾 Pet Portrait",
    "mode.portraitDesc": "Your photo, your style, your Punch", "mode.sceneDesc": "", "mode.petDesc": "Your best friend. A new unforgettable look",
    "upload.title": "Sube tu foto",
    "upload.subtitle": "Arrastra o haz clic. Soporta JPG, PNG, HEIC, HEIF, WEBP, AVIF, BMP, TIFF hasta 10MB",
    "upload.cta": "Elegir foto", "upload.formats": "JPG, PNG, HEIC, WEBP, AVIF, BMP, TIFF · 10MB",
    "upload.generate": "Generate Style", "upload.deliveryInfo": "Your artwork will be generated after payment and delivered on the next screen.", "upload.generating": "Generando cartoon…",
    "upload.demoReady": "Demo lista — paga para desbloquear HD sin marca de agua",
    "pricing.title": "Precios", "pricing.subtitle": "Paga una vez. Descarga para siempre. Sin suscripción.",
    "pricing.popular": "Más popular", "pricing.buy": "Comprar ahora",
    "pricing.feat1": "Descarga Full HD", "pricing.feat2": "Sin marca de agua", "pricing.feat3": "Licencia comercial", "pricing.feat4": "Entrega instantánea",
    "pack.pickStyles": "Elige {n} estilos", "pack.allStyles": "Los 9 estilos incluidos",
    
    "footer.tagline": "",
    "footer.rights": "Todos los derechos reservados", "footer.privacy": "Política de Privacidad", "footer.terms": "Términos y Condiciones", "footer.cookies": "Política de Cookies",
    "footer.builtBy": "Hecho por SupremeCommerce.eu",
    "gdpr.text": "Usamos cookies para mejorar tu experiencia. Al usar PunchInk aceptas nuestra Política de Cookies.",
    "gdpr.accept": "Aceptar", "gdpr.decline": "Rechazar",
    "checkout.title": "Completar compra", "checkout.processing": "Procesando pago…",
    "checkout.success": "¡Pago exitoso! Tu cartoon HD está listo.", "checkout.download": "Descargar HD", "checkout.cancel": "Cancelar",
    "checkout.downloadAll": "Descargar todos", "checkout.itemSingle": "1 Cartoon HD", "checkout.itemMulti": "{n} Cartoons HD",
    "checkout.includes": "Incluye licencia comercial, sin marca de agua, full HD.",
    "checkout.payWith": "Pagar con Stripe", "checkout.secure": "Pago seguro · TLS 256-bit · Sin almacenar datos de tarjeta",
    "common.lastUpdated": "Última actualización",
    "privacy.title": "Política de Privacidad",
    "privacy.intro": "PunchInk (\"nosotros\") respeta tu privacidad. Esta política explica cómo recopilamos, usamos y protegemos tu información en punchink.com.",
    "privacy.s1Title": "1. Datos que recopilamos",
    "privacy.s1i1": "Fotos que subes para generar retratos cartoon.",
    "privacy.s1i2": "Email y metadatos de pago procesados por Stripe.",
    "privacy.s1i3": "Análisis anónimos (visitas, idioma preferido).",
    "privacy.s2Title": "2. Cómo los usamos",
    "privacy.s2Body": "Las fotos subidas se procesan solo para generar el cartoon solicitado. Se eliminan de nuestros servidores en 24 horas a menos que las guardes explícitamente.",
    "privacy.s3Title": "3. Datos de pago",
    "privacy.s3Body": "Todos los pagos los procesa Stripe. Nunca vemos ni almacenamos el número completo de tu tarjeta.",
    "privacy.s4Title": "4. Tus derechos GDPR",
    "privacy.s4i1": "Derecho de acceso, rectificación y supresión de tus datos.",
    "privacy.s4i2": "Derecho a la portabilidad y a presentar reclamación ante tu APD.",
    "privacy.s4i3": "Escríbenos por email para ejercer estos derechos.",
    "privacy.s5Title": "5. Menores", "privacy.s5Body": "PunchInk no está dirigido a usuarios menores de 13 años.",
    "privacy.s6Title": "6. Contacto",
    "terms.title": "Términos y Condiciones",
    "terms.s1Title": "1. Servicio",
    "terms.s1Body": "PunchInk ofrece retratos cartoon generados por IA basados en las fotos que subes. Al usar el Servicio aceptas estos Términos.",
    "terms.s2Title": "2. Tu contenido",
    "terms.s2Body": "Confirmas tener los derechos o el permiso para subir cualquier foto. No subas imágenes que infrinjan derechos de terceros, contengan contenido ilegal o representen a menores en contextos inapropiados.",
    "terms.s3Title": "3. Licencia que recibes",
    "terms.s3Body": "Tras el pago exitoso, recibes una licencia mundial, perpetua y no exclusiva para usar el cartoon HD para fines personales y comerciales.",
    "terms.s4Title": "4. Reembolsos",
    "terms.s4Body": "Como cada cartoon se genera de forma única, todas las ventas son finales. Contáctanos si una generación falla.",
    "terms.s5Title": "5. Uso aceptable",
    "terms.s5i1": "Sin discurso de odio, acoso o contenido sexualmente explícito.",
    "terms.s5i2": "Sin suplantación de figuras públicas reales sin consentimiento.",
    "terms.s5i3": "Sin scraping automatizado ni abuso de nuestras APIs.",
    "terms.s6Title": "6. Responsabilidad",
    "terms.s6Body": "El Servicio se ofrece \"tal cual\". En la medida permitida por la ley, la responsabilidad total de PunchInk se limita al monto pagado en los últimos 12 meses.",
    "terms.s7Title": "7. Ley aplicable",
    "terms.s7Body": "Estos Términos se rigen por las leyes de la Unión Europea. Las disputas se resolverán en los tribunales competentes del estado miembro de la UE donde SupremeCommerce EOOD esté registrada.",
    "cookies.title": "Política de Cookies",
    "cookies.s1Title": "1. ¿Qué son las cookies?",
    "cookies.s1Body": "Las cookies son pequeños archivos de texto guardados en tu dispositivo que ayudan a los sitios web a funcionar y a recordar tus preferencias.",
    "cookies.s2Title": "2. Cookies que usamos",
    "cookies.s2i1": "Esenciales: idioma, consentimiento GDPR, sesión.",
    "cookies.s2i2": "Análisis: estadísticas anónimas para mejorar el Servicio.",
    "cookies.s2i3": "Pago: Stripe usa cookies durante el checkout para prevenir fraude.",
    "cookies.s3Title": "3. Gestionar cookies",
    "cookies.s3Body": "Puedes aceptar o rechazar cookies no esenciales mediante el banner GDPR de la primera visita. También puedes borrar cookies en la configuración de tu navegador en cualquier momento.",
    "cookies.s4Title": "4. Terceros",
    "cookies.s4Body": "Usamos Stripe (pagos) y nuestro proveedor de análisis. Cada uno opera bajo su propia política de cookies.",
    "cookies.s5Title": "5. Contacto",
  },
  tr: {
    "nav.styles": "Stiller", "nav.pricing": "Fiyatlar", "nav.reviews": "Yorumlar", "nav.cta": "Şimdi dene",
    "hero.tag": "AI Karikatür Portre Stüdyosu", "hero.title": "Senin Punch Stilin",
    "hero.subtitle": "Bir fotoğraf yükle, bir stil seç ve saniyeler içinde harika HD karikatür portreni al",
    "hero.cta": "Stilimi oluştur",
    "hero.stat1": "mutlu kullanıcı", "hero.stat2": "ortalama puan", "hero.stat3": "teslim",
    "examples.title": "Sihri görün", "examples.subtitle": "PunchInk'ten gerçek öncesi ve sonrası örnekleri",
    "examples.before": "Önce", "examples.after": "Sonra",
    "examples.petsNote": "Evcil hayvanlar tüm stillerle çalışır!",
    "styles.title": "Stilini seç", "styles.subtitle": "",
    "style.cartoon": "Klasik Karikatür", "style.anime": "Anime / Manga", "style.disney": "Disney / Pixar",
    "style.comic": "Çizgi Roman", "style.neon": "Neon", "style.ghibli": "Ghibli", "style.oil": "Yağlı Boya",
    "style.headshot": "Headshot", "style.caricature": "Karikatür",
    "style.neon.desc": "Siberpunk neon parıltısı, yüz korunması ~80%",
    "style.anime.desc": "Anime sanat tarzı, yüz korunması ~75%",
    "style.comic.desc": "Cesur çizgi roman tarzı, yüz korunması ~85%",
    "style.cartoon.desc": "Klasik çizgi film tarzı, yüz korunması ~70%",
    "style.ghibli.desc": "Studio Ghibli büyüsü, yüz korunması ~75%",
    "style.oil.desc": "Yağlı boya portre, yüz korunması ~90%",
    "style.disney.desc": "3D animasyon tarzı, yüz korunması ~70%",
    "style.headshot.desc": "Profesyonel portre fotoğrafı, yüz korunması ~80%",
    "style.caricature.desc": "Yakın çekim fotoğraflarda en iyi sonuç 😄",
    "mode.portrait": "👤 My Portrait", "mode.scene": "Tam Sahne", "mode.pet": "🐾 Pet Portrait",
    "mode.portraitDesc": "Your photo, your style, your Punch", "mode.sceneDesc": "", "mode.petDesc": "Your best friend. A new unforgettable look",
    "upload.title": "Fotoğrafını yükle",
    "upload.subtitle": "Sürükle bırak veya tıkla. JPG, PNG, HEIC, HEIF, WEBP, AVIF, BMP, TIFF 10MB'a kadar destekler",
    "upload.cta": "Fotoğraf seç", "upload.formats": "JPG, PNG, HEIC, WEBP, AVIF, BMP, TIFF · 10MB",
    "upload.generate": "Generate Style", "upload.deliveryInfo": "Your artwork will be generated after payment and delivered on the next screen.", "upload.generating": "Karikatür oluşturuluyor…",
    "upload.demoReady": "Demo hazır — filigransız HD için ödeme yap",
    "pricing.title": "Fiyatlar", "pricing.subtitle": "Bir kez öde. Sonsuza dek indir. Abonelik yok.",
    "pricing.popular": "En popüler", "pricing.buy": "Şimdi al",
    "pricing.feat1": "Full HD indirme", "pricing.feat2": "Filigran yok", "pricing.feat3": "Ticari lisans", "pricing.feat4": "Anında teslim",
    "pack.pickStyles": "{n} stil seç", "pack.allStyles": "9 stilin tümü dahil",
    
    "footer.tagline": "",
    "footer.rights": "Tüm hakları saklıdır", "footer.privacy": "Gizlilik Politikası", "footer.terms": "Şartlar ve Koşullar", "footer.cookies": "Çerez Politikası",
    "footer.builtBy": "SupremeCommerce.eu tarafından geliştirildi",
    "gdpr.text": "Hizmetlerimizi sunmak ve deneyiminizi iyileştirmek için çerez kullanırız. PunchInk kullanarak Çerez Politikamızı kabul etmiş olursunuz.",
    "gdpr.accept": "Kabul et", "gdpr.decline": "Reddet",
    "checkout.title": "Satın almayı tamamla", "checkout.processing": "Ödeme işleniyor…",
    "checkout.success": "Ödeme başarılı! HD karikatürün hazır.", "checkout.download": "HD indir", "checkout.cancel": "İptal",
    "checkout.downloadAll": "Tümünü indir", "checkout.itemSingle": "1 HD Karikatür", "checkout.itemMulti": "{n} HD Karikatür",
    "checkout.includes": "Ticari lisans, filigransız, full HD dahil.",
    "checkout.payWith": "Stripe ile öde", "checkout.secure": "Güvenli ödeme · 256-bit TLS · Kart bilgisi saklanmaz",
    "common.lastUpdated": "Son güncelleme",
    "privacy.title": "Gizlilik Politikası",
    "privacy.intro": "PunchInk (\"biz\") gizliliğinize saygı duyar. Bu politika, punchink.com'da bilgilerinizi nasıl topladığımızı, kullandığımızı ve koruduğumuzu açıklar.",
    "privacy.s1Title": "1. Topladığımız veriler",
    "privacy.s1i1": "Karikatür portre oluşturmak için yüklenen fotoğraflar.",
    "privacy.s1i2": "Stripe tarafından işlenen e-posta ve ödeme meta verileri.",
    "privacy.s1i3": "Anonim analizler (sayfa görüntülemeleri, dil tercihi).",
    "privacy.s2Title": "2. Nasıl kullanırız",
    "privacy.s2Body": "Yüklenen fotoğraflar yalnızca istediğiniz karikatürü oluşturmak için AI servisimiz tarafından işlenir. Açıkça kaydetmediğiniz sürece 24 saat içinde sunucularımızdan silinir.",
    "privacy.s3Title": "3. Ödeme verileri",
    "privacy.s3Body": "Tüm ödemeler Stripe tarafından işlenir. Tam kart numaranızı asla görmez veya saklamayız.",
    "privacy.s4Title": "4. GDPR haklarınız",
    "privacy.s4i1": "Verilerinize erişim, düzeltme ve silme hakkı.",
    "privacy.s4i2": "Veri taşınabilirliği ve veri koruma kurumuna şikayet hakkı.",
    "privacy.s4i3": "Bu hakları kullanmak için bize e-posta gönderin.",
    "privacy.s5Title": "5. Çocuklar", "privacy.s5Body": "PunchInk 13 yaşın altındaki kullanıcılar için tasarlanmamıştır.",
    "privacy.s6Title": "6. İletişim",
    "terms.title": "Şartlar ve Koşullar",
    "terms.s1Title": "1. Hizmet",
    "terms.s1Body": "PunchInk, yüklediğiniz fotoğraflara dayalı AI tarafından oluşturulan karikatür portreler sunar. Hizmeti kullanarak bu Şartları kabul etmiş olursunuz.",
    "terms.s2Title": "2. İçeriğiniz",
    "terms.s2Body": "Yüklediğiniz herhangi bir fotoğrafın sahibi veya yükleme izniniz olduğunu doğrulamış olursunuz. Üçüncü taraf haklarını ihlal eden, yasa dışı içerik içeren veya küçükleri uygunsuz şekilde gösteren görseller yüklemeyin.",
    "terms.s3Title": "3. Aldığınız lisans",
    "terms.s3Body": "Başarılı ödemenin ardından, ortaya çıkan HD karikatürü kişisel ve ticari amaçlarla kullanmak için dünya çapında, süresiz, münhasır olmayan bir lisans alırsınız.",
    "terms.s4Title": "4. İadeler",
    "terms.s4Body": "Her karikatür size özel oluşturulduğundan tüm satışlar kesindir. Bir oluşturma başarısız olursa bizimle iletişime geçin.",
    "terms.s5Title": "5. Kabul edilebilir kullanım",
    "terms.s5i1": "Nefret söylemi, taciz veya cinsel açıdan müstehcen içerik yok.",
    "terms.s5i2": "Onay olmadan gerçek tanınmış kişilerin taklidi yok.",
    "terms.s5i3": "API'larımızın otomatik kazıması veya kötüye kullanılması yok.",
    "terms.s6Title": "6. Sorumluluk",
    "terms.s6Body": "Hizmet \"olduğu gibi\" sağlanır. Yasaların izin verdiği ölçüde, PunchInk'in toplam sorumluluğu son 12 ayda ödediğiniz tutarla sınırlıdır.",
    "terms.s7Title": "7. Geçerli kanun",
    "terms.s7Body": "Bu Şartlar Avrupa Birliği yasalarına tabidir. Anlaşmazlıklar SupremeCommerce EOOD'nin kayıtlı olduğu AB üye devletinin yetkili mahkemelerinde çözülür.",
    "cookies.title": "Çerez Politikası",
    "cookies.s1Title": "1. Çerezler nedir?",
    "cookies.s1Body": "Çerezler, web sitelerinin çalışmasına ve tercihlerinizi hatırlamasına yardımcı olan, cihazınızda saklanan küçük metin dosyalarıdır.",
    "cookies.s2Title": "2. Kullandığımız çerezler",
    "cookies.s2i1": "Zorunlu: dil tercihi, GDPR onay durumu, oturum.",
    "cookies.s2i2": "Analiz: hizmeti iyileştirmek için anonim kullanım istatistikleri.",
    "cookies.s2i3": "Ödeme: Stripe, dolandırıcılığı önlemek için ödeme sırasında çerez ayarlar.",
    "cookies.s3Title": "3. Çerez yönetimi",
    "cookies.s3Body": "İlk ziyarette gösterilen GDPR bannerı üzerinden zorunlu olmayan çerezleri kabul edebilir veya reddedebilirsiniz. Tarayıcı ayarlarınızdan dilediğiniz zaman çerezleri silebilirsiniz.",
    "cookies.s4Title": "4. Üçüncü taraflar",
    "cookies.s4Body": "Stripe (ödemeler) ve analiz sağlayıcımıza güveniyoruz. Her biri kendi çerez politikası altında çalışır.",
    "cookies.s5Title": "5. İletişim",
  },
};
